import "reflect-metadata";

import { container, inject, injectable, singleton } from "tsyringe";

import {
  constructor,
  ExtractValue,
  IDi,
  IDiDecorator,
  Register,
} from "@/backend/domains/di/domain/Di";

//

export class TsyringeDi<Registers extends Record<string, Register>> extends IDi<Registers> {
  public resolve_core<K extends keyof Registers & string>(token: K): ExtractValue<Registers, K> {
    return container.resolve(token);
  }

  //

  protected register<T>(token: string, provider: constructor<T>): string {
    container.registerSingleton(token, provider);
    return token;
  }

  //

  protected registerValue(token: string, value: unknown): string {
    container.register(token, { useValue: value });
    return token;
  }
}

//

export class TsyringeDiDecorator<Tokens extends string> implements IDiDecorator<Tokens> {
  public inject(
    token: Tokens,
  ): (target: unknown, propertyKey: string | symbol | undefined, parameterIndex: number) => void {
    return inject(token);
  }

  //

  public injectable<T>(): (target: constructor<T>) => void {
    return injectable();
  }

  //

  public singleton<T>(): (target: constructor<T>) => void {
    return singleton();
  }
}
